import React from "react";
import { createContext, useRef } from "react";

export const AssignContext = createContext();
export const AssignContextprovider = ({children}) => {
    const selectedAssigneeList = useRef([])

    return(
        <AssignContext.Provider
            value={{selectedAssigneeList}}>

            {children}
            
        </AssignContext.Provider>
    )
}